import type { Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/system';

function mixinSx(
  ...sxes: Array<SxProps<Theme> | undefined | false>
): SxProps<Theme> {
  return sxes.filter((sx) => sx != null && sx !== false).flat();
}

export default mixinSx;
